import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from '@/localization';
import Locale from '@/lib/Locale';

Vue.use(VueI18n);

const LOCAL_STORAGE_LANGUAGE_KEY = 'selectedLanguage';

const defaultLocale = Locale.GetFallbackLocale();
const initialLocale: string = Locale.GetCurrentLocale();

const options: VueI18n.I18nOptions = {
    locale: initialLocale,
    fallbackLocale: defaultLocale,
    silentFallbackWarn: true,
    messages: messages
};

export const i18n = new VueI18n(options);
